import { OrderPaymentMethod } from '../../../graphql/graphql';
import useTranslation from '../../../Hooks/useTranslation';

const paymentMethodsLabels: Record<OrderPaymentMethod, string> = {
	[OrderPaymentMethod.Apay]: 'Apple Pay',
	[OrderPaymentMethod.Gpay]: 'Google Pay',
	[OrderPaymentMethod.Crd]: 'base.paymentMethods.paymentCard',
	[OrderPaymentMethod.Sodexo]: 'Sodexo',
	[OrderPaymentMethod.Edenred]: 'Edenred',
	[OrderPaymentMethod.MeddiCredit]: 'base.paymentMethods.meddiCredit',
	[OrderPaymentMethod.Paypal]: 'PayPal',
	[OrderPaymentMethod.Voucher]: 'Voucher',
};

export default function usePaymentMethod() {
	const { t } = useTranslation();

	const getPaymentMethodLabel = (paymentMethod: OrderPaymentMethod): string => {
		return t(paymentMethodsLabels[paymentMethod]) ?? paymentMethod;
	};

	return {
		getPaymentMethodLabel,
	};
}
